export const getLoadMoreContent = () => {
let result;
  if (result) return Promise.resolve(result);
  return import('./load-more-btn-new').then((module) => {
    result = module;
    return module;
  });
};